import * as eventType from '../../shared/constants/eventType'
import { pushEventAction } from 'Events/shared/actions/pushEvent'

// TODO remove isNewEvent
export function pushRevenueAction (isNewEvent, revenue, cameFrom) {
  return pushEventAction({ ...revenue, type: eventType.inType }, cameFrom, 'receipt-form')
}
